import { extend } from 'vee-validate';

extend('c_number_only', (value) => {
  const adjustedValue = value.toLowerCase();
  if (!adjustedValue.charAt(0).match(/[c]/i)) return 'Identifier must begin with a C';
  if (isNaN(adjustedValue.charAt(1) - parseFloat(adjustedValue.charAt(1)))) return 'Identifier must contain a number after the letter C';
  try {
    [...value].forEach((char, index) => {
      if (index < 1) return;
      if (isNaN(char - parseFloat(char))) throw Error();
    });
  } catch (error) {
    return 'Identifier can only contain numbers after the letter C';
  }

  return true;
});